import { BuyerService } from './../../services/buyer.service';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from './../../services/authentication.service';
import { AccountDeactiveComponent } from './../account-deactive/account-deactive.component';
import { LoginComponent } from './../login/login.component';
import { RegistrationComponent } from './../registration/registration.component';
import { BsModalService, ModalOptions, BsModalRef } from 'ngx-bootstrap/modal';
import { EventBusService } from './../../services/event-bus-service';
import { Component, OnInit } from '@angular/core';
import { ForgetPasswordComponent } from '../forget-password/forget-password.component';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { ActivatedRoute, Router } from '@angular/router';
import constants from '../../utility/constants';
import messages from '../../utility/messages';
import { ReturningUserResetPasswordComponent } from '../returning-user-reset-password/returning-user-reset-password.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-public-index',
  templateUrl: './public-index.component.html',
  styleUrls: ['./public-index.component.css'],
})
export class PublicIndexComponent implements OnInit {
  private subscriptions: Array<Subscription> = [];

  constructor(
    private ebs: EventBusService,
    private modalService: BsModalService,
    public modalRef: BsModalRef,
    private authenticationService: AuthenticationService,
    private toastr: ToastrService,
    private buyerService: BuyerService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const notification = this.ebs.notification.subscribe((data: any) => {
      let modalOptions: ModalOptions = {
        backdrop: 'static',
        keyboard: false,
        class: 'custom-popup user-login modal-dialog modal-dialog-centered',
      };
      if (data == 'register') {
        this.modalRef = this.modalService.show(RegistrationComponent, modalOptions);
      } else if (data == 'login') {
        this.modalRef = this.modalService.show(LoginComponent, modalOptions);
      } else if (data == 'forget-password') {
        this.modalRef = this.modalService.show(ForgetPasswordComponent, modalOptions);
      } else if (data == 'returning-user-forgot-password') {
        this.modalRef = this.modalService.show(ReturningUserResetPasswordComponent, modalOptions);
      } else if (data.modal == 'deactivate') {
        this.modalRef = this.modalService.show(AccountDeactiveComponent, modalOptions);
        this.modalRef.content = data.email;
      } else if (data.modal == 'reset-password') {
        this.modalRef = this.modalService.show(ResetPasswordComponent, modalOptions);
        this.modalRef.content = data.token;
      }
    });
    this.subscriptions.push(notification)
    this.route.params.subscribe((params: any) => {
      if (this.router.url.split('/')[1] == 'activate') {
        let hash = params['token'];
        this.buyerService.activate(hash).subscribe(
          () => {
            this.toastr.success(
              messages.publicHome.activated,
              constants.common.toast.successTitle,
              constants.common.toast.config
            );
            this.router.navigate(['']);
          },
          (error) => {
            this.toastr.error(
              error,
              constants.common.toast.errorTitle,
              constants.common.toast.config
            );
            this.router.navigate(['']);
          }
        );
      }
      if (this.router.url.split('/')[1] == 'user-reset-password') {
        let modalOptions: ModalOptions = {
          backdrop: 'static',
          keyboard: false,
          class: 'custom-popup user-login modal-dialog modal-dialog-centered',
        };
        let hash = params['token'];
        const validatePwd = this.authenticationService
          .validatePasswordLink(hash)
          .subscribe((res: any) => {
            if (res.data == true) {
              this.router.navigate(['']);
              this.modalRef = this.modalService.show(
                ResetPasswordComponent,
                modalOptions
              );
              this.modalRef.content = hash;
            } else {
              this.toastr.error(
                'Reset password link has expired',
                constants.common.toast.errorTitle,
                constants.common.toast.config
              );
              this.router.navigate(['']);
            }
          });
          this.subscriptions.push(validatePwd)
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
